// React imports.
import React from "react";

import { Assessment2StepsEnum } from "../state";
import { Assessment2FuelStatusEnum } from "../state";


const Assessment2Questions = ({fuelType, state }) => (
    <div>

        <ol>
            <li>
                Do client waivers meet {fuelType.description}&nbsp;vendors' requirements?<br/>
                <label>
                    <input type="radio"
                        name="clientWaiversMeetVendorRequirements"
                        id="clientWaiversMeetVendorRequirements_true"
                        value="true"
                        checked={fuelType.clientWaiversMeetVendorRequirements === true}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="clientWaiversMeetVendorRequirements"
                        id="clientWaiversMeetVendorRequirements_false"
                        value="false"
                        checked={fuelType.clientWaiversMeetVendorRequirements === false}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.clientWaiversMeetVendorRequirements === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.clientWaiversMeetVendorRequirements === false
                  && <span><strong>Requires followup.</strong>&nbsp; If vendors feel that a state's client wavier does not meet their
                        requirements for data security and privacy, they may refuse to furnish expenditure data to the
                        LIHEAP office.  Grant Recipients should check with vendors to ensure that client waivers meet vendor data security
                        and privacy standards
                        <br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="clientWaiversMeetVendorRequirementsDesc"
                          id="clientWaiversMeetVendorRequirementsDesc" style={{width:"100%"}}
                          value={fuelType.clientWaiversMeetVendorRequirementsDesc}
                          onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}></textarea>
                      </span>

                  }
                <br/>
            </li>
            <li>
                Do {fuelType.description}&nbsp;vendors' agreements have data collection requirements?<br/>
                <label>
                    <input type="radio"
                        name="vendorAgreementsHaveDataCollectionRequirements"
                        id="vendorAgreementsHaveDataCollectionRequirements_true"
                        value="true"
                        checked={fuelType.vendorAgreementsHaveDataCollectionRequirements === true}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="vendorAgreementsHaveDataCollectionRequirements"
                        id="vendorAgreementsHaveDataCollectionRequirements_false"
                        value="false"
                        checked={fuelType.vendorAgreementsHaveDataCollectionRequirements === false}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.vendorAgreementsHaveDataCollectionRequirements === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.vendorAgreementsHaveDataCollectionRequirements === false
                    && <span><strong>Requires followup.</strong>&nbsp; LIHEAP Grant Recipients are required to collect data from&nbsp;
                    {fuelType.description}  vendors.  Vendor agreements should include data collection requirements
                    to ensure that sufficient data can be collected and reported.
                    <br/>
                    Please indicate your plans to address this issue in the box below
                    <textarea  name="vendorAgreementsHaveDataCollectionRequirementsDesc"
                        id="vendorAgreementsHaveDataCollectionRequirementsDesc" style={{width:"100%"}}
                        value={fuelType.vendorAgreementsHaveDataCollectionRequirementsDesc}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>
                }
                <br/>
            </li>
            <li>
                Are {fuelType.description}&nbsp;vendors alerted about data collection in a timely manner?<br/>
                <label>
                    <input type="radio"
                        name="vendorsAlertedTimelyManner"
                        id="vendorsAlertedTimelyManner_true"
                        value="true"
                        checked={fuelType.vendorsAlertedTimelyManner === true}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="vendorsAlertedTimelyManner"
                        id="vendorsAlertedTimelyManner_false"
                        value="false"
                        checked={fuelType.vendorsAlertedTimelyManner === false}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.vendorsAlertedTimelyManner === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.vendorsAlertedTimelyManner === false
                  && <span><strong>Requires followup.</strong>&nbsp; If vendors do not receive requests for data collection well in advance,
                    there is an increased risk that the vendor will not be able to supply the data before the reporting deadline.
                    All vendors should be alerted about upcoming data collection in a timely manner, well before the
                    reporting deadline.
                    <br/>
                    Please indicate your plans to address this issue in the box below
                    <textarea  name="vendorsAlertedTimelyMannerDesc"
                        id="vendorsAlertedTimelyMannerDesc" style={{width:"100%"}}
                        value={fuelType.vendorsAlertedTimelyMannerDesc}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>
                  }<br/ >
            </li>
            
        
            {fuelType.showAccountNumberQuestion === true
            && <li>
                Do all of your {fuelType.description}&nbsp;vendors use an account number (rather than a simple name and address system) to track customer expenditures? 
                <br/>
                <label>
                    <input type="radio"
                        name="vendorsUseAccountNumberFlag"
                        id="vendorsUseAccountNumberFlag_true"
                        value="true"
                        checked={fuelType.vendorsUseAccountNumberFlag === true}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="vendorsUseAccountNumberFlag"
                        id="vendorsUseAccountNumberFlag_false"
                        value="false"
                        checked={fuelType.vendorsUseAccountNumberFlag === false}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                <br/ >
                {fuelType.vendorsUseAccountNumberFlag === true
                  && <span><strong>No action needed</strong></span>}
                {fuelType.vendorsUseAccountNumberFlag === false
                  && <span><strong>Requires followup.</strong>&nbsp;
                    Using account number is the simplest and often the most efficient way to track customer expenditures.
                    Fuel oil vendors who choose not to use account numbers need be aware that their vendor agreements and
                    contracts obligate them to provide accurate expenditure information for their LIHEAP customers anyway. 
                    <br/>
                    Please indicate your ideas or plans for addressing this issue in the response box below.
                    <textarea  name="vendorsUseAccountNumberDesc"
                        id="vendorsUseAccountNumberDesc" style={{width:"100%"}}
                        value={fuelType.vendorsUseAccountNumberDesc}
                        onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>
                  }<br/ >
            </li>
            }

            {(fuelType.showSetUpMeeting == true && fuelType.viewAnyway != true)
            && <li>
                Based on your responses to the follow-up questions, it looks like your potential data
                reliability issue is not explained by any of the most common problems for data
                collection. Please set up a meeting with your {fuelType.description}&nbsp;vendors to figure out
                what can be done to ensure that you receive all the necessary data.
                <br/><br/>
                Please document any ideas or possible solutions to this issue in the response box below.
                <textarea  name="setUpMeetingDesc"
                    id="setUpMeetingDesc" style={{width:"100%"}}
                    value={fuelType.setUpMeetingDesc}
                    onChange={(changeEvent) => state.assessment2FieldChangeHandler(changeEvent, fuelType)}></textarea>
            </li>
            }
        </ol>

        {(fuelType.showSetUpMeeting == true && fuelType.viewAnyway === true)
        && <p>
              Based on your responses to the follow-up questions, it looks like you are
              not facing any of the most common problems that arise during data collection.
              If you still have concerns or questions regarding data reliability and data
              collection please contact APPRISE.
          </p>
        }

    </div>
);

export default Assessment2Questions;
